export default __webpack_public_path__ + "aada0213078d13f0053a90189277e2bd.png";